import { apiClient } from './client';
// Helper to append mock flag
function appendMock(url, mock) {
    if (!mock)
        return url;
    return url + (url.includes('?') ? '&' : '?') + 'useMock=true';
}
export const dashboardApi = {
    getTotalLeadsGenerated: (workspaceId, range, mock) => {
        // Backend route: /api/Dashboards/{workspaceId}/TotalLeadsGenerated/{range}
        return apiClient.get(appendMock(`/api/Dashboards/${encodeURIComponent(workspaceId)}/TotalLeadsGenerated/${encodeURIComponent(range)}`, mock));
    },
    getCompaniesEngaged: (workspaceId, range, mock) => {
        // Backend route: /api/Dashboards/{workspaceId}/CompaniesEngaged/{range}
        return apiClient.get(appendMock(`/api/Dashboards/${encodeURIComponent(workspaceId)}/CompaniesEngaged/${encodeURIComponent(range)}`, mock));
    },
    getActiveCampaigns: (workspaceId, mock) => {
        // Backend route: /api/Dashboards/{workspaceId}/ActiveCampaigns
        return apiClient.get(appendMock(`/api/Dashboards/${encodeURIComponent(workspaceId)}/ActiveCampaigns`, mock));
    },
    getActiveWebs: (workspaceId, mock) => {
        // Backend route: /api/Dashboards/{workspaceId}/ActiveWebs
        return apiClient.get(appendMock(`/api/Dashboards/${encodeURIComponent(workspaceId)}/ActiveWebs`, mock));
    },
    getNewestConversions: (workspaceId, limit = 5, mock) => {
        // Backend route: /api/Dashboards/{workspaceId}/NewestConversions?limit={limit}
        const qp = new URLSearchParams({ limit: String(limit) });
        return apiClient.get(appendMock(`/api/Dashboards/${encodeURIComponent(workspaceId)}/NewestConversions?${qp.toString()}`, mock));
    },
    getHottestCompanies: (workspaceId, limit = 5, mock) => {
        // Backend route: /api/Dashboards/{workspaceId}/HottestCompanies?limit={limit}
        const qp = new URLSearchParams({ limit: String(limit) });
        return apiClient.get(appendMock(`/api/Dashboards/${encodeURIComponent(workspaceId)}/HottestCompanies?${qp.toString()}`, mock));
    },
    getCampaignPerformance: (workspaceId, mock) => {
        // Backend route: /api/Dashboards/{workspaceId}/CampaignPerformance
        return apiClient.get(appendMock(`/api/Dashboards/${encodeURIComponent(workspaceId)}/CampaignPerformance`, mock));
    },
    getTopPerformingWebs: (workspaceId, limit = 5, mock) => {
        // Backend route: /api/Dashboards/{workspaceId}/TopPerformingWebs?limit={limit}
        const qp = new URLSearchParams({ limit: String(limit) });
        return apiClient.get(appendMock(`/api/Dashboards/${encodeURIComponent(workspaceId)}/TopPerformingWebs?${qp.toString()}`, mock));
    },
    getHottestLeads: (workspaceId, limit = 5, mock) => {
        // Backend route: /api/Dashboards/{workspaceId}/HottestLeads?limit={limit}
        const qp = new URLSearchParams({ limit: String(limit) });
        return apiClient.get(appendMock(`/api/Dashboards/${encodeURIComponent(workspaceId)}/HottestLeads?${qp.toString()}`, mock));
    },
    getLeadsBySource: (workspaceId, range, mock) => {
        // Backend route: /api/Dashboards/{workspaceId}/LeadsBySource/{range}
        return apiClient.get(appendMock(`/api/Dashboards/${encodeURIComponent(workspaceId)}/LeadsBySource/${encodeURIComponent(range)}`, mock));
    },
    // ---------------- Campaign-scoped dashboard endpoints ----------------
    getCampaignTotalLeadsGenerated: (workspaceId, campaignId, range, mock) => {
        return apiClient.get(appendMock(`/api/Dashboards/${encodeURIComponent(workspaceId)}/Campaigns/${encodeURIComponent(campaignId)}/TotalLeadsGenerated/${encodeURIComponent(range)}`, mock));
    },
    getCampaignCompaniesEngaged: (workspaceId, campaignId, range, mock) => {
        return apiClient.get(appendMock(`/api/Dashboards/${encodeURIComponent(workspaceId)}/Campaigns/${encodeURIComponent(campaignId)}/CompaniesEngaged/${encodeURIComponent(range)}`, mock));
    },
    getCampaignActiveWebs: (workspaceId, campaignId, mock) => {
        return apiClient.get(appendMock(`/api/Dashboards/${encodeURIComponent(workspaceId)}/Campaigns/${encodeURIComponent(campaignId)}/ActiveWebs`, mock));
    },
    getCampaignNewestConversions: (workspaceId, campaignId, limit = 5, mock) => {
        const qp = new URLSearchParams({ limit: String(limit) });
        return apiClient.get(appendMock(`/api/Dashboards/${encodeURIComponent(workspaceId)}/Campaigns/${encodeURIComponent(campaignId)}/NewestConversions?${qp.toString()}`, mock));
    },
    getCampaignHottestCompanies: (workspaceId, campaignId, limit = 5, mock) => {
        const qp = new URLSearchParams({ limit: String(limit) });
        return apiClient.get(appendMock(`/api/Dashboards/${encodeURIComponent(workspaceId)}/Campaigns/${encodeURIComponent(campaignId)}/HottestCompanies?${qp.toString()}`, mock));
    },
    getCampaignHottestLeads: (workspaceId, campaignId, limit = 5, mock) => {
        const qp = new URLSearchParams({ limit: String(limit) });
        return apiClient.get(appendMock(`/api/Dashboards/${encodeURIComponent(workspaceId)}/Campaigns/${encodeURIComponent(campaignId)}/HottestLeads?${qp.toString()}`, mock));
    },
    getCampaignTopPerformingWebs: (workspaceId, campaignId, limit = 5, mock) => {
        const qp = new URLSearchParams({ limit: String(limit) });
        return apiClient.get(appendMock(`/api/Dashboards/${encodeURIComponent(workspaceId)}/Campaigns/${encodeURIComponent(campaignId)}/TopPerformingWebs?${qp.toString()}`, mock));
    },
    getCampaignLeadsBySource: (workspaceId, campaignId, range, mock) => {
        return apiClient.get(appendMock(`/api/Dashboards/${encodeURIComponent(workspaceId)}/Campaigns/${encodeURIComponent(campaignId)}/LeadsBySource/${encodeURIComponent(range)}`, mock));
    }
};
